import { jsx as _jsx } from "react/jsx-runtime";
import { useCurrentUser } from "@sprout/client-graphql";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { useCallback, useMemo } from "react";
import { LabelsDialog } from "../Dialog_next";
import useMultiselectDialog from "./useMultiselectDialog";
export default function useLabelGlobalHandler({ items: items1 , rootTopicId , labels  }) {
    const { dialog , selectedItemIds , openDialog , closeDialog  } = useMultiselectDialog();
    const currentUser = useCurrentUser();
    const selectedItems = useMemo(()=>{
        return items1.filter((item)=>selectedItemIds.includes(item.id));
    }, [
        items1,
        selectedItemIds
    ]);
    useActionRegistryGlobalHandler("LABEL", useCallback((items)=>{
        return openDialog({
            items: [
                ...items
            ],
            dialog: "label"
        });
    }, [
        openDialog
    ]), {
        skip: !currentUser
    });
    return /*#__PURE__*/ _jsx(LabelsDialog, {
        open: dialog === "label",
        selectedItems: selectedItems,
        onRequestClose: closeDialog,
        labels: labels,
        rootTopicId: rootTopicId
    });
};
